/* eslint-disable no-case-declarations */
/* eslint-disable indent */
/* eslint-disable camelcase */
import { nanoid } from 'nanoid'
import { cloneDeep } from 'lodash'
import store from '../../store'
import { CURB_LANE_WIDTH, CURB_LANE_WIDTH_VALUES } from '../constants/freight'
import { addSegment, updateFinalStreet } from './multimodal.utils'

export function setFreightStreetmixInput(field) {
  const { freight, street } = store.getState()
  const { curb_lane_width } = freight
  const { segments } = street

  switch (field) {
    case CURB_LANE_WIDTH:
      let segmentCopy = cloneDeep(segments)
      // segmentCopy = removeAllTruckLanes(segmentCopy)
      // const truckLane = {
      //   type: 'drive-lane',
      //   elevation: 0
      // }
      // Check if input is NO Bike Lane

      const firstLaneIndex = segmentCopy.findIndex(
        (segment) => segment?.type.indexOf('drive-lane') !== -1
      )
      // Check if road is one way or two way
      const segmentDirection = segmentCopy.map((segment) =>
        segment.type === 'drive-lane' && segment?.variant?.direction
          ? segment?.variant?.direction
          : null
      )
      const isRoadTwoWay =
        segmentDirection?.includes('inbound') &&
        segmentDirection?.includes('outbound')

      // if no drive lanes, add trcuk lane in-between segments
      if (firstLaneIndex === -1) {
        const midSegmentIndex = Math.floor(segmentCopy.length / 2)
        if (curb_lane_width === CURB_LANE_WIDTH_VALUES[2]) {
          segmentCopy = addSegment(
            midSegmentIndex,
            {
              ...truckLane,
              id: nanoid(),
              variantString: 'inbound|truck',
              variant: { direction: 'inbound', 'car-type': 'truck' },
              width: 11.5
            },
            segmentCopy
          )
        } else if (curb_lane_width === CURB_LANE_WIDTH_VALUES[3]) {
          segmentCopy = addSegment(
            midSegmentIndex,
            {
              ...truckLane,
              id: nanoid(),
              variantString: 'inbound|truck',
              variant: { direction: 'inbound', 'car-type': 'truck' },
              width: 13
            },
            segmentCopy
          )
        } else if (curb_lane_width === CURB_LANE_WIDTH_VALUES[1]) {
          segmentCopy = addSegment(
            midSegmentIndex,
            {
              ...truckLane,
              id: nanoid(),
              variantString: 'inbound|truck',
              variant: { direction: 'inbound', 'car-type': 'truck' },
              width: 11
            },
            segmentCopy
          )
        } else if (curb_lane_width === CURB_LANE_WIDTH_VALUES[0]) {
          segmentCopy = addSegment(
            midSegmentIndex,
            {
              ...truckLane,
              id: nanoid(),
              variantString: 'inbound|truck',
              variant: { direction: 'inbound', 'car-type': 'truck' },
              width: 10
            },
            segmentCopy
          )
        }
        updateFinalStreet(segmentCopy)
        return
      }

      if (curb_lane_width === CURB_LANE_WIDTH_VALUES[2]) {
        // segmentCopy = addSegment(
        //   firstLaneIndex,
        //   {
        //     ...truckLane,
        //     id: nanoid(),
        //     variantString: 'inbound|truck',
        //     variant: { direction: 'inbound', 'car-type': 'truck' },
        //     width: 11.5
        //   },
        //   segmentCopy
        // )
        segmentCopy.forEach((segment, index) => {
          if (index === firstLaneIndex) {
            segment.width = 11.5
          }
        })
      } else if (curb_lane_width === CURB_LANE_WIDTH_VALUES[3]) {
        // segmentCopy = addSegment(
        //   firstLaneIndex,
        //   {
        //     ...truckLane,
        //     id: nanoid(),
        //     variantString: 'inbound|truck',
        //     variant: { direction: 'inbound', 'car-type': 'truck' },
        //     width: 13
        //   },
        //   segmentCopy
        // )
        segmentCopy.forEach((segment, index) => {
          if (index === firstLaneIndex) {
            segment.width = 13
          }
        })
      } else if (curb_lane_width === CURB_LANE_WIDTH_VALUES[1]) {
        // segmentCopy = addSegment(
        //   firstLaneIndex,
        //   {
        //     ...truckLane,
        //     id: nanoid(),
        //     variantString: 'inbound|truck',
        //     variant: { direction: 'inbound', 'car-type': 'truck' },
        //     width: 11
        //   },
        //   segmentCopy
        // )
        segmentCopy.forEach((segment, index) => {
          if (index === firstLaneIndex) {
            segment.width = 11
          }
        })
      } else if (curb_lane_width === CURB_LANE_WIDTH_VALUES[0]) {
        // segmentCopy = addSegment(
        //   firstLaneIndex,
        //   {
        //     ...truckLane,
        //     id: nanoid(),
        //     variantString: 'inbound|truck',
        //     variant: { direction: 'inbound', 'car-type': 'truck' },
        //     width: 10
        //   },
        //   segmentCopy
        // )
        segmentCopy.forEach((segment, index) => {
          if (index === firstLaneIndex) {
            segment.width = 10
          }
        })
      }

      // If road is two way then implement remaining segments
      if (isRoadTwoWay) {
        // Reverse segments to find last lane id
        const copyOfSegmentsToReverse = [...segmentCopy]

        const lastLaneId = copyOfSegmentsToReverse
          .reverse()
          .find((segment) => segment?.type.indexOf('drive-lane') !== -1)?.id

        const lastLandeIndex = segmentCopy.findIndex(
          (segment) => segment?.id === lastLaneId
        )

        if (curb_lane_width === CURB_LANE_WIDTH_VALUES[2]) {
          // segmentCopy = addSegment(
          //   lastLandeIndex + 1,
          //   {
          //     ...truckLane,
          //     id: nanoid(),
          //     variantString: 'outbound|truck',
          //     variant: { direction: 'outbound', 'car-type': 'truck' },
          //     width: 11.5
          //   },
          //   segmentCopy
          // )
          segmentCopy.forEach((segment, index) => {
            if (index === lastLandeIndex) {
              segment.width = 11.5
            }
          })
        } else if (curb_lane_width === CURB_LANE_WIDTH_VALUES[3]) {
          // segmentCopy = addSegment(
          //   lastLandeIndex + 1,
          //   {
          //     ...truckLane,
          //     id: nanoid(),
          //     variantString: 'outbound|truck',
          //     variant: { direction: 'outbound', 'car-type': 'truck' },
          //     width: 13
          //   },
          //   segmentCopy
          // )
          segmentCopy.forEach((segment, index) => {
            if (index === lastLandeIndex) {
              segment.width = 13
            }
          })
        } else if (curb_lane_width === CURB_LANE_WIDTH_VALUES[1]) {
          // segmentCopy = addSegment(
          //   lastLandeIndex + 1,
          //   {
          //     ...truckLane,
          //     id: nanoid(),
          //     variantString: 'outbound|truck',
          //     variant: { direction: 'outbound', 'car-type': 'truck' },
          //     width: 11
          //   },
          //   segmentCopy
          // )
          segmentCopy.forEach((segment, index) => {
            if (index === lastLandeIndex) {
              segment.width = 11
            }
          })
        } else if (curb_lane_width === CURB_LANE_WIDTH_VALUES[0]) {
          // segmentCopy = addSegment(
          //   lastLandeIndex + 1,
          //   {
          //     ...truckLane,
          //     id: nanoid(),
          //     variantString: 'outbound|truck',
          //     variant: { direction: 'outbound', 'car-type': 'truck' },
          //     width: 10
          //   },
          //   segmentCopy
          // )
          segmentCopy.forEach((segment, index) => {
            if (index === lastLandeIndex) {
              segment.width = 10
            }
          })
        }
      }
      updateFinalStreet(segmentCopy)
  }
}

function removeAllTruckLanes(segmentCopy) {
  // get all truck lane indexes
  const truckLaneIndexArr = segmentCopy
    .map((segment, index) => {
      if (
        segment?.type === 'drive-lane' &&
        segment?.variantString.includes('truck')
      ) {
        return index
      } else {
        return null
      }
    })
    .filter((index) => index !== null)
  return segmentCopy.filter(
    (segment, index) => !truckLaneIndexArr.includes(index)
  )
}
